import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body no-padding" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}
const _hoisted_12 = {
  key: 1,
  class: "text-center"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-devices-list", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-xl",
      role: "document",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("List of active devices")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Date")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("IP address")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Operating system")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("Web browser")), 1),
                _hoisted_10
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, (s) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: s.session
                }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.renderDate(s.created)), 1),
                  _createElementVNode("td", null, _toDisplayString(s.remote), 1),
                  _createElementVNode("td", null, _toDisplayString(s.os), 1),
                  _createElementVNode("td", null, _toDisplayString(s.browser), 1),
                  (s.current)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_11, "(" + _toDisplayString(_ctx.$t("Current session")) + ")", 1))
                    : _createCommentVNode("", true),
                  (!s.current)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-sm",
                          onClick: ($event: any) => (_ctx.closeSession(s.session))
                        }, _toDisplayString(_ctx.$t("Close session")), 9, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
            class: "btn btn-primary"
          }, _toDisplayString(_ctx.$t("Done")), 1)
        ]),
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.error), 1)
      ])
    ])
  ], 42, _hoisted_1))
}